"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../constants");
var _Svg = _interopRequireDefault(require("../../Svg/Svg"));
var _Link = _interopRequireDefault(require("../../Link/Link"));
var SOLFooter = function SOLFooter(_ref) {
  var socialLinks = _ref.socialLinks;
  return /*#__PURE__*/_react["default"].createElement("footer", {
    className: "d8-u-component-padding sol-footer d8-u-text-center d8-u-color-white"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center margin-bottom-xl max-width-sm margin-auto"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-white text-xxxxl margin-bottom-xxs golddrew"
  }, "CONTACT US"), /*#__PURE__*/_react["default"].createElement("p", null, "Yacht Week isn't your average getaway, and getting things in order requires some planning on your end. Fret not, though; we've got your back every step of the way. Whether it's a call, email, Whatsapp message, or live chat, we're here to assist with any advice you may need."), /*#__PURE__*/_react["default"].createElement("div", {
    className: "padding-y-md"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: "https://calendly.com/day8/30min?month=2024-01",
    className: "btn btn--primary margin-top-md text-bold block longer-link margin-bottom-xs"
  }, "Book a call"), /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: "/contact",
    className: "btn btn--primary margin-top-md text-bold margin-bottom-xs"
  }, "Other options")))), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm text-center d8-u-text-semi-bold"
  }, "Follow the voyages"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-center margin-y-lg"
  }, socialLinks.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      key: JSON.stringify(item),
      href: item.link,
      external: true
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex flex-center margin-x-md d8-u-icon-size d8-u-white-bg radius-50% padding-xs"
    }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      className: "icon--sm",
      name: item.icon,
      fill: _constants.COLORS.PRIMARY_DARKER
    })));
  })));
};
SOLFooter.propTypes = {
  socialLinks: _propTypes["default"].array
};
SOLFooter.defaultProps = {
  socialLinks: [{
    link: 'https://www.facebook.com/theyachtweek',
    icon: 'facebook'
  }, {
    link: 'https://instagram.com/theyachtweek/',
    icon: 'instagram'
  }, {
    link: 'https://vm.tiktok.com/ZMRJfhnj5/',
    icon: 'tiktok'
  }, {
    link: 'https://www.youtube.com/user/TheYachtWeek',
    icon: 'youtube-brand'
  }]
};
var _default = exports["default"] = SOLFooter;